angular.module("ainapp")
    .controller("AssetListController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Asset List";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }



            $scope.Init = function () {
                $scope.filter = {
                    Keyword: ""
                }

            }
            $scope.Init();

            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        o.data.ProductType = "Asset";
                        o.data.Keyword = $scope.filter.Keyword;
                        MainService.ProductList(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        })
                    },

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            Name: {
                                type: "string",
                                editable: false,
                            },
                            NameAr: {
                                type: "string",
                                editable: false,
                            },
                            ProductCode: {
                                type: "string",
                                editable: false,
                            },
                            "Unit.Name": {
                                type: "string",
                                editable: false,
                            },
                            BarCode: {
                                type: "string",
                                editable: false,
                            },
                            GroupName: {
                                type: "string",
                                editable: false,
                            },
                            ParentGroupName: {
                                type: "string",
                                editable: false,
                            },
                            SellPrice: {
                                type: "number",
                                editable: false,
                            },
                            PurchasePrice: {
                                type: "number",
                                editable: false,
                            },
                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,
                aggregate: [{
                    field: "BalanceValue",
                    aggregate: "sum"
                    }, {
                    field: "Balance",
                    aggregate: "sum"
                    }, ],
            });

            $scope.KendoGridOptions = {



                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 600,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: true,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },



                columns: [
                    {
                        field: "Name",
                        title: "Name",
                        headerTemplate: "{{LanguageData.Name}}",
                        },
                    {
                        field: "NameAr",
                        title: "Arabic Name",
                        },
                    {
                        field: "ProductCode",
                        title: "Product Code",
                        },
                    {
                        field: "ParentGroupName",
                        title: "Parent Group",
                        },
                    {
                        field: "GroupName",
                        title: " Group",
                        },
                    {
                        field: "BarCode",
                        title: "Bar Code",
                        },
                    {
                        field: "Unit.Name",
                        title: "Unit",
                        },
                    {
                        field: "SellPrice",
                        title: "Sell Price",
                        template: "<div style='text-align: right'>#=kendo.toString(SellPrice, 'n')#</div>",

                        },
                    {
                        field: "PurchasePrice",
                        title: "Purchase Price",
                        template: "<div style='text-align: right'>#=kendo.toString(PurchasePrice, 'n')#</div>",

                        },

                    {
                        title: "Options",
                        headerTemplate: "{{LanguageData.Options}}  ",
                        template: "<button class=' btn-default btn-sm fa fa-pencil' ng-click='Edit(dataItem)'> </button> <button class=' btn-default btn-sm fa fa-trash'  ng-click='deleteProduct(dataItem)'></button> </button> <button class=' btn-default btn-sm fa fa-print'  ng-click='printPdf(dataItem)'></button>  </button> <button class=' btn-default btn-sm fa fa-id-card'  ng-click='printLabel(dataItem)'></button>  <button ng-if='CompanyProfile.IsRecipe' class=' btn-default btn-sm fa fa-bars'  ng-click='goRecipe(dataItem)'></button>",
                        width: '160px'
                        },
                    ],
            };

            $scope.search = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }

            $scope.refresh = function () {
                $scope.Init();
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }

            $scope.goRecipe = function (data) {
                $state.go("recipe", {
                    productId: data.Id
                })
            }


            $scope.Edit = function (data) {
                $state.go("editAsset", {
                    ItemId: data.Id
                })
            }

            $scope.SelectedDataForDelete = {};
            $scope.deleteProduct = function (data) {
                $scope.SelectedDataForDelete = data;
                $("#deletemodal").modal("show");
            }

            $scope.deleteWithConfirm = function () {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteProduct($scope.SelectedDataForDelete.Id).then(function (response) {
                    if (response.data == 1) {
                        $('#deletemodal').modal('hide');
                        toastr.success("Deleted");
                        $scope.SelectedDataForDelete = {};
                        $scope.Init();
                    } else if (response.data == 2) {
                        $('#deletemodal').modal('hide');
                        toastr.warning("Product In Use");
                    } else if (response.data == 3) {
                        $('#deletemodal').modal('hide');
                        toastr.warning("Delete Sub Products First");
                    } else {
                        toastr.warning("Failed");
                    }
                    $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                    $.LoadingOverlay("hide");
                }, function (err) {
                    $.LoadingOverlay("hide");
                    toastr.error("Network Error");
                });
            }



        }])
